<template>
  <div class="message-module">
    <div class="content">
      <div class="message-broad">
        <img
          :src="require('@/assets/images/horn.png')"
          class="horn"
        >
        <div class="carousel">
          <ul
            ref="slideContainer"
            :style="{transform: `translateY(-${indexTest * 32}px)`}"
          >
            <li
              v-for="(item, index) in messageList"
              :key="index"
            >
              {{ item }}
            </li>
            <li>{{ messageList[0] }}</li>
          </ul>
        </div>
      </div>
      <img
        :src="require('@/assets/images/message-board-close-icon.png')"
        @click="closeMessageBroad"
        class="close-icon"
      >
    </div>
  </div>
</template>

<script>
import client from '@/client'
export default {
  name: 'MessageBroad',
  props: {
    messageBroadList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      messageList: [],
      indexTest: 0
    }
  },

  created () {
    this.messageList = this.messageBroadList
    this.rotationListener()
  },
  mounted () {
    // 消息广播展示上报
    client.home.REPORT.reportHomeOperate({ main_click: 0, order_notice: 1 })
  },
  methods: {
    rotationListener () {
      setInterval(() => {
        this.indexTest++
      }, 3000)

      this.$nextTick(() => {
        this.$refs.slideContainer.addEventListener('transitionend', () => {
          if (this.indexTest === this.messageList.length) {
            this.indexTest = 0
            this.$refs.slideContainer.style.transition = 'none'
            setTimeout(() => {
              this.$refs.slideContainer.style.transition = 'all .4s'
            })
          }
        })
      })
    },
    closeMessageBroad () {
      // 消息广播关闭上报
      client.home.REPORT.reportHomeOperate({ main_click: 92, order_notice: 2 })
      this.$emit('closeMessageBroad')
    }
  }
}
</script>

<style lang="scss" scoped>
.message-module {
  position: fixed;
  z-index: 10;
  top: 121px;
  left: 1px;
  height: 28px;
  width: calc(100% - 2px);
  background-color: #fff;
  background-color: red;

  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    margin-top: 0px;
    padding: 0 12px 0 19px;
    width: 700px;
    height: 28px;
    box-sizing: border-box;
    background-color: #FFEEC4;

    .message-broad {
      display: flex;
      align-items: center;

      .horn {
        width: 16px;
        height: 16px;
      }

      .carousel {
        margin-left: 8px;
        height: 28px;
        font-size: 12px;
        font-weight: 400;
        color: #995A00;
        overflow: hidden;

        ul {
          transition: all .4s;
          li {
            line-height: 28px;
            height: 100%;
            width: 532px;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    .close-icon {
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
}
</style>
